import React, { useState } from "react";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Paper,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import PhoneField from "../../common/input/PhoneField";
import EmailInput from "../../common/component/EmailInput";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router";
import { validateCustomer } from "../../common/util";
import bkstApi from "../../api";
import CloseIcon from "@mui/icons-material/Close";

export default function EditCustomer(props) {
  const { customerId, customer } = props;
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [open, setOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [errors, setErrors] = useState([]);

  const submit = (e) => {
    e.preventDefault();

    const arr = validateCustomer({ firstName, lastName, phone, email });
    setErrors(arr);
    if (arr.length > 0) {
      return;
    } else {
      setProcessing(true);
      const payload = { firstName, lastName, phone, email, src: customer.src };
      bkstApi.put(`/my/customer/${customerId}`, payload).then((res) => {
        navigate(0);
      });
    }
  };

  const handleOpen = () => {
    setFirstName(props.customer.firstName);
    setLastName(props.customer.lastName);
    setPhone(props.customer.phone);
    setEmail(props.customer.email);
    setErrors([]);
    setOpen(true);
  };

  if (!open) {
    return (
      <IconButton size="small" onClick={handleOpen}>
        <EditIcon fontSize="small" />
      </IconButton>
    );
  } else {
    return (
      <Dialog fullScreen={true} open={open} scroll="paper">
        <form
          onSubmit={submit}
          style={{
            display: "contents",
          }}
        >
          <DialogTitle
            sx={{
              padding: "7px 20px",
              display: "flex",
              gap: "10px",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "0",
              backgroundColor: "#DEDEDE",
              borderBottom: "3px solid #DEDEDE",
            }}
          >
            <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <IconButton onClick={() => setOpen(false)}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h5">Edit Customer</Typography>
            </Box>
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ backgroundColor: "#F7F7F7" }}>
            <Container maxWidth="sm">
              <Box py={4}>
                {errors && errors.length > 0 && (
                  <Box my={2}>
                    <Alert severity="error">{errors.join(", ")}</Alert>
                  </Box>
                )}
                <Paper elevation={0}>
                  <Box px={2} py={4}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <FormControl variant="outlined" fullWidth>
                          <TextField
                            value={firstName}
                            variant="outlined"
                            fullWidth
                            id="firstName"
                            label="First Name"
                            name="firstName"
                            onChange={(e) => setFirstName(e.target.value)}
                            required
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl variant="outlined" fullWidth>
                          <TextField
                            value={lastName}
                            variant="outlined"
                            fullWidth
                            id="lastName"
                            label="Last Name"
                            name="lastName"
                            onChange={(e) => setLastName(e.target.value)}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl variant="outlined" fullWidth>
                          <PhoneField
                            name="Phone"
                            value={phone}
                            onChange={(phone) => setPhone(phone)}
                            required
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <EmailInput value={email} onChange={(val) => setEmail(val)} />
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
                <Box my={2}>
                  <Alert severity="warning">
                    When you save your changes, all open orders & quotes for this customer will be
                    updated with the new customer details. If a customer profile with the same first
                    name & phone exists, then the two profiles will be merged.
                  </Alert>
                </Box>
                <Button type="submit" fullWidth color="primary" variant="contained">
                  SAVE
                </Button>
              </Box>
            </Container>
          </DialogContent>
        </form>
        {processing && (
          <Backdrop open={true} style={{ zIndex: "1000", color: "#fff" }}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </Dialog>
    );
  }
}
